import { defineComponent as _defineComponent } from 'vue'
import useEnvCheck from "@/composables/useEnvCheck";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EnvironmentIndicator',
  props: {
    environment: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const { envCheck } = useEnvCheck();

const props = __props;

const currentEnvironment = computed(() => {
  if (props.environment) {
    return props.environment;
  }

  return envCheck();
});

const __returned__ = { envCheck, props, currentEnvironment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})